<hawk-record-navigation
  class="common_style app-page"
  *ngIf="project"
  [breadcrumbLinkList]="[
    { description: 'Projekte', link: '/a/projekt' },
    { description: project.name, link: '/a/projekt/' + project.id },
  ]"
  [root]="'project'"
  [leafDescription]="'Tickets importieren'"
>
  <div class="page-content page-frame overflow-y-auto">
    <div class="page-sheet mx-auto min-w-xl" style="width: fit-content;">
      <section class="bm-card max-w-xl">
        <div class="bm-card-body">
          <h2 class="bm-card-title flex flex-row justify-between">
            Format
            <button class="bm-btn bm-btn-sm bm-btn-circle" (click)="showFormatModal = true">
              <fa-icon [icon]="faInfoCircle" />
            </button>
          </h2>
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label">Header-Zeile</label>
            <select class="bm-select w-full" [(ngModel)]="headerFormat" [disabled]="!!file">
              <option [value]="true">Vorhanden (Zeile 1 überspringen)</option>
              <option [value]="false">Nicht vorhanden</option>
            </select>

            <div class="input_row">
              <div class="input_label"></div>
              <div style="flex: 1" class="flex_col">
                <div class="input_container">
                  @if (file) {
                    <div>
                      Auswahl: {{ file.name }}
                      <fa-icon style="cursor: pointer" [icon]="faTrash" (click)="resetFile()"></fa-icon>
                    </div>
                  }
                  <input
                    #fileInput
                    type="file"
                    class="bm-file-input w-full"
                    (change)="incomingFile($event)"
                    [disabled]="!alreadyCreatedExternalIds"
                    placeholder="Upload file"
                    accept=".xlsx"
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </section>

      @if (ticketImportUnits?.length) {
        <div class="flex flex-row items-center justify-end py-2">
          <input
            type="text"
            class="bm-input"
            placeholder="Schnellfilter..."
            (input)="ticketQuickSearchChanged($event)"
          />
        </div>
        <ag-grid-angular
          class="ag-theme-quartz"
          style="height: 480px; min-width: 90vw;"
          [rowData]="ticketImportUnits"
          [theme]="hawkTheme"
          [defaultColDef]="defaultColDef"
          [columnDefs]="ticketColDefs"
          [rowClassRules]="rowClassRules"
          [rowSelection]="rowSelection"
          [autoSizeStrategy]="autoSizeStrategy"
          [paginationPageSize]="16"
          [localeText]="locale"
          [sideBar]="sideBarOptions"
          [paginationPageSizeSelector]="[16, 32, 64, 128]"
          (gridReady)="onTicketGridReady($event)"
        />
      }
      <ng-container [ngTemplateOutlet]="tplErrors"/>
      <div>
        @if (showSuccess) {
          <small class="text-success">{{ showSuccess }}</small>
        } @else if (showError) {
          <small class="text-error">Fehler: {{ showError }}</small>
        } @else {
          @if (ticketImportUnits?.length && !importableUnits?.length) {
            <small> Hinweis: Alle Tickets wurden importiert! </small>
          }
          @if (importableUnits?.length) {
            <small>
              Hinweis: Noch {{ importableUnits?.length }}/{{ ticketImportUnits?.length }} Ticket(s) zum importieren
            </small>
          }
        }

        @if (Number.isFinite(uploadProgress) && uploadProgress >= 0) {
          <hawk-progress-bar [progress]="uploadProgress"/>
          <div class="bm-label">Upload bei: {{Math.round(uploadProgress)}}%...</div>
        }
      </div>

      <div class="flex flex-row justify-end gap-2 mt-4">
        <a [routerLink]="'/projekt/' + project.id" class="bm-btn"> Abbrechen </a>

        <button
          class="bm-btn bm-btn-primary"
          (click)="bulkImportTickets()"
          [disabled]="(Number.isFinite(uploadProgress) && uploadProgress >= 0) ||
                      (priorityErrorGroup && !priorityErrorGroup.valid) ||
                      (statusErrorGroup && !statusErrorGroup.valid) ||
                      (nonExistingStores?.length || nonProjectStores?.length)"
        >
          Importieren
        </button>
      </div>
    </div>
  </div>
</hawk-record-navigation>

@if (showFormatModal) {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box" style="max-width: none;">
      <h3 class="text-lg font-bold">Beschreibung Excel Format</h3>
      <a
        class="bm-link bm-link-hover"
        download="TicketImport.xlsx"
        href="assets/example-files/TicketImport.xlsx"
      >
        Beispiel Excel runterladen
      </a>

      <div style="overflow-x: auto;">
        <table class="bm-table bm-table-xs bm-table-zebra text-nowrap w-full overflow-x-auto">
          <tr>
            <td>
            <span [tooltip]="'ticket.external_order_nr'">
              Externe Auftragsnummer <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
            </td>
            <td>
            <span [tooltip]="'ticket.status_id'">
              Status <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
            </td>
            <td>
            <span [tooltip]="'ticket.priority_id'">
              Priorität <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
            </td>
            <td>
            <span [tooltip]="'store.nr oder store.address_company'">
              Filiale <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
            </td>
            <td>Kontaktname</td>
            <td>E-Mail</td>
            <td>Telefon</td>
            <td>Fehlertext</td>
            <td>
            <span [tooltip]="'operation.operation_date'">
              Datum und Uhrzeit <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
            </td>
            <td>
            <span [tooltip]="'user.id (default: 283)'">
              Techniker <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
            </td>
            <td>
            <span [tooltip]="'ticket.time_estimation'">
              Zeit <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
            </td>
          </tr>
          <tr>
            <td>0</td>
            <td>1718</td>
            <td>757</td>
            <td>Blume2000 (6040)</td>
            <td></td>
            <td></td>
            <td></td>
            <td>Wartung der Filiale - Prüfung auch technische Fehler, Kontrolle der Verkabelung. </td>
            <td>24.12.2025 08:00</td>
            <td>283</td>
            <td>30</td>
          </tr>
          <tr>
            <td>...</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>

      <div class="bm-modal-action">
        <button class="bm-btn bm-btn-primary" (click)="showFormatModal = false">Schließen</button>
      </div>
    </div>
  </dialog>
}

<ng-template #tplErrors>

  @if (nonExistingStores) {
    <div class="my-2">
      <section>
        <div class="bm-alert bm-alert-error bm-alert-soft" *ngIf="nonExistingStores.length">
          Filialen existieren nicht
          <small class="text-muted">Bitte legen Sie zuerst folgende Filialen an, um die Tickets zu importieren</small>
          <a [routerLink]="'/filiale/neu'" target="_blank">
            <button class="bm-btn">Filialen anlegen</button>
          </a>
        </div>
        <div class="bm-alert bm-alert-success bm-alert-soft" *ngIf="!nonExistingStores.length">
          Filialen gefunden!
        </div>
        <div class="flex flex-row flex-wrap">
          @for (store of nonExistingStores; track $index) {
            <div class="px-2" style="width: 12.5%">
              {{ store.name }}
            </div>
          }
        </div>
      </section>
    </div>
  }
  @if (nonProjectStores) {
    <div class="my-2">
      <section>
        <div class="bm-alert bm-alert-warning bm-alert-soft" *ngIf="nonProjectStores.length">
          Filialen nicht mit Projekt verknüpft
          <small class="text-muted">Bitte verknüpfen Sie die Filialen mit dem Projekt, um die Tickets zu importieren</small>
          <button class="bm-btn" (click)="addAllProjectStores()">Alle Filialen verknüpfen</button>
        </div>
        <div class="bm-alert bm-alert-success bm-alert-soft" *ngIf="!nonProjectStores.length">
          Filialen verknüpft!
        </div>
        <div class="flex flex-row flex-wrap">
          @for (store of nonProjectStores; track $index) {
            <div class="px-2" style="width: 12.5%">
              {{ store.name }}
            </div>
          }
        </div>
      </section>
    </div>
  }
  @if (priorityErrorGroup) {
    <div class="my-2">
      <section>
        <div class="bm-alert bm-alert-warning bm-alert-soft" *ngIf="!priorityErrorGroup.valid">
          Prioritäten nicht gefunden
          <small class="text-muted">Bitte ordnen Sie die richtige Priorität zu</small>
        </div>
        <div class="bm-alert bm-alert-success bm-alert-soft" *ngIf="priorityErrorGroup.valid">
          Prioritäten zugeordnet!
        </div>
        <form [formGroup]="priorityErrorGroup" class="flex flex-row flex-wrap">
          @for (field of Object.keys(priorityErrorGroup.controls); track $index) {
            <div class="px-2" style="width: 12.5%">
              <label class="bm-fieldset-label">Zuordnung von "{{ field }}"</label>
              <select class="bm-select" [formControlName]="field">
                <option [ngValue]="null">-</option>
                <option *ngFor="let priority of priorities" [value]="priority.id">
                  ID {{ priority.id }} - {{ priority.name }}
                </option>
              </select>
            </div>
          }
        </form>
      </section>
    </div>
  }
  @if (statusErrorGroup) {
    <div class="my-2">
      <section>
        <div class="bm-alert bm-alert-warning bm-alert-soft" *ngIf="!statusErrorGroup.valid">
          Status nicht gefunden
          <small class="text-muted">Bitte ordnen Sie den richtigen Status zu</small>
        </div>
        <div class="bm-alert bm-alert-success bm-alert-soft" *ngIf="statusErrorGroup.valid">
          Status zugeordnet!
        </div>
        <form [formGroup]="statusErrorGroup" class="flex flex-row flex-wrap">
          @for (field of Object.keys(statusErrorGroup.controls); track $index) {
            <div class="px-2" style="width: 12.5%">
              <label class="bm-fieldset-label">Zuordnung von "{{ field }}"</label>
              <select class="bm-select" [formControlName]="field">
                <option [ngValue]="null">-</option>
                <option *ngFor="let status_item of status" [value]="status_item.id">
                  ID {{ status_item.id }} - {{ status_item.name }}
                </option>
              </select>
            </div>
          }
        </form>
      </section>
    </div>
  }
</ng-template>
